<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4"><a id="page_24"></a><a id="sec8"></a>Words</h4>
<p class="poem">Parole. Mote in one’s own eye. The deceit<br/>That a lifetime is. I wasn’t there<br/>When something happened. Something</p>
<p class="poem">Happened. A chair was pushed out from a table.<br/>Don’t listen if you don’t want to know<br/>What happened, the Sergeant said. I don’t want to know</p>
<p class="poem">The future as it’s seen on that inked slip of paper<br/>That says one has only now and no more.<br/>It was fourth grade or fifth.</p>
<p class="poem">Or it was eighth grade or the grade up the side<br/>Of the river or the ditch at the side of the road.<br/>It was very steep. It’s always been difficult.</p>
<p class="poem">Breath like a hollow rasp but almost silent.<br/>A management that keeps one sane. A hand gliding<br/>An iron over a piece of fabric.</p>
<p class="poem">Like skates, like a sewing stitch<br/>Done to keep one’s attention from wavering.<br/>The self talking to a mirror.</p>
<p class="poem">All the doctors know that. The ones who see you lying<br/>On a sofa. They know that there is a sound<br/>In one’s head. They know there is that deep</p>
<p class="poem">Relief from the waking state called sleep. How little else<br/>They know unless you tell them. I tell them<br/>I wish I could lie under the summer.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1_d.vue?5c7ea77d